import { LanguageOutlined } from "@mui/icons-material";
import {
	Box,
	ClickAwayListener,
	List,
	ListItemButton,
	ListItemText,
	Paper,
	Popper,
	Typography,
	useMediaQuery
} from '@mui/material';
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import { useTheme } from '@mui/material/styles';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import Images from "../../../assets";
import { Languages } from "../../../helpers/constants";
import useUserAction from "../../../hooks/user/useUserAction";
import useUserData from "../../../hooks/user/useUserData";
import Transitions from "../../@extended/transitions.jsx";

const LanguageSelect = (props) => {
	const {
		color = '#FFFFFF'
	} = props
	const theme = useTheme();
	const matchesXs = useMediaQuery(theme.breakpoints.down('md'));
	const { setUserLanguage } = useUserAction()
	const { language } = useUserData()
	const { i18n } = useTranslation()
	useEffect(() => {
		i18n.changeLanguage(language)
	}, [i18n, language])
	
	const anchorRef = useRef(null);
	const [open, setOpen] = useState(false);
	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};
	
	const handleClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}
		setOpen(false);
	};
	
	const handleListItemClick = (lang) => {
		setUserLanguage(lang);
		setOpen(false);
	};
	
	return (
		<Box sx={{ flexShrink: 0, ml: 0.75 }}>
			<Button
				aria-label="open localization"
				ref={anchorRef}
				aria-controls={open ? 'localization-grow' : undefined}
				aria-haspopup="true"
				onClick={handleToggle}
				size={'large'}
				startIcon={<LanguageOutlined/>}
				sx={{ fontWeight: 'bold', minWidth: '100px', color: color }}
				variant={'outlined'}
			>
				<Typography
					pl={1}
					component={'span'}
					variant={'button'}
				>
					{language === Languages.EN ? 'EN' : 'GR'}
				</Typography>
			</Button>
			<Popper
				placement={matchesXs ? 'bottom-start' : 'bottom'}
				open={open}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
				popperOptions={{
					modifiers: [
						{
							name: 'offset',
							options: {
								offset: [matchesXs ? 0 : 0, 9]
							}
						}
					]
				}}
			>
				{({ TransitionProps }) => (
					<Transitions type="grow" position={matchesXs ? 'top-right' : 'top'} in={open} {...TransitionProps}>
						<Paper sx={{ boxShadow: theme.customShadows.z1 }}>
							<ClickAwayListener onClickAway={handleClose}>
								<List
									component="nav"
									sx={{
										p: 0,
										width: '100%',
										minWidth: 200,
										maxWidth: 290,
										bgcolor: theme.palette.background.paper,
										borderRadius: 0.5,
										[theme.breakpoints.down('md')]: {
											maxWidth: 250
										}
									}}
								>
									<ListItemButton selected={language === Languages.EN}
													onClick={() => handleListItemClick(Languages.EN)}>
										<ListItemText
											primary={
												<Grid container alignItems={'center'} gap={1}>
													<img src={Images.englishFlag} alt={'English flag'} width={'30px'}/>
													<Typography color="textPrimary">English</Typography>
													<Typography variant="caption" color="textSecondary">
														(EN)
													</Typography>
												</Grid>
											}
										/>
									</ListItemButton>
									<ListItemButton selected={language === Languages.EL}
													onClick={() => handleListItemClick(Languages.EL)}>
										<ListItemText
											primary={
												<Grid container alignItems={'center'} gap={1}>
													<img src={Images.greekFlag} alt={'Greek flag'} width={'30px'}/>
													<Typography color="textPrimary">Ελληνικά</Typography>
													<Typography variant="caption" color="textSecondary">
														(GR)
													</Typography>
												</Grid>
											}
										/>
									</ListItemButton>
								</List>
							</ClickAwayListener>
						</Paper>
					</Transitions>
				)}
			</Popper>
		</Box>
	);
};

export default LanguageSelect;
